import React from 'react';

interface MiniAvaProps {
  apiKey: string;
  baseUrl: string;
  context?: string;
  includeContext?: boolean;
  showAttachments?: boolean;
  showTools?: boolean;
}

export const MiniAva = ({
  apiKey,
  baseUrl,
  context = '',
  includeContext = true,
  showAttachments = true,
  showTools = false
}: MiniAvaProps) => {
  return React.createElement('mini-ava', {
    'api-key': apiKey,
    'base-url': baseUrl,
    context,
    'include-context': includeContext.toString(),
    'show-attachments': showAttachments.toString(),
    'show-tools': showTools.toString()
  });
};
